import { useState } from 'react'

import { useDebouncedCallback } from 'use-debounce'

import { SearchedTrack } from 'src/Pages/Artist/CreateCampaignPage/Components/TrackSearch'
import { DEBOUNCE_TIMER_1000 } from 'src/Constants/constants'
import { useLazySearchPlaylistQuery } from 'src/Redux/search-playlistApi'
import { cutPlaylistId } from 'src/Utils/cutPlaylistId'

type UsePlaylistSearch = {
  searchPlaylist: (query: string) => void
  isLoading: boolean
  playlists: SearchedTrack[]
  error: string | null
  onClearPlaylist: () => void
}

const errorMessages =
  'Oops! It looks like the URL you entered is not valid. Please make sure you have entered a correct web address and try searching again.'

export const usePlaylistSearch = (): UsePlaylistSearch => {
  const [error, setError] = useState<string | null>(null)
  const [result, setResult] = useState<SearchedTrack[]>([])
  const [search, { isLoading }] = useLazySearchPlaylistQuery()

  const searchPlaylist = (query: string): void => {
    setError(null)
    setResult([])
    if (!query) {
      return
    }
    const playlistId = cutPlaylistId(query)
    if (!playlistId) {
      setError(errorMessages)
      return
    }
    search(playlistId)
      .unwrap()
      .then((res) => {
        setResult([res])
      })
      .catch(() => {
        setError(errorMessages)
      })
  }

  const debouncedFindPlaylist = useDebouncedCallback(
    searchPlaylist,
    DEBOUNCE_TIMER_1000,
  )

  const onClearPlaylist = (): void => {
    setResult([])
  }

  return {
    error,
    isLoading,
    onClearPlaylist,
    playlists: result,
    searchPlaylist: debouncedFindPlaylist,
  }
}
